import swaggerClient from '../../utility/swaggerClient';

export const login = async (username, password, ipAddress,deviceInfo) => {
  const client = await swaggerClient();
  const response = (await client.apis.login.post_user_login({
    login: {
      username,
      password,
      ipAddress,
      deviceInfo
    }
  })).body;
  console.log(response);
  return response;
};

export const logout = () =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, 1000);
  });





// WEBPACK FOOTER //
// ./src/state/auth/api.js